module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inOne-records"
  }, [_c('form', [_c('div', {
    staticClass: "inOne-TabRecords"
  }, [_c('h3', {
    staticClass: "headTitle"
  }, [_vm._v("主诉")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.mainSuit),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "mainSuit", $$v)
      },
      expression: "diagnose.mainSuit"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "headTitle"
  }, [_vm._v("现病史")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.hpi),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "hpi", $$v)
      },
      expression: "diagnose.hpi"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "headTitle"
  }, [_vm._v("既往辅助检查")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.assistantExamination),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "assistantExamination", $$v)
      },
      expression: "diagnose.assistantExamination"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "headTitle"
  }, [_vm._v("刻下")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.kexia),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "kexia", $$v)
      },
      expression: "diagnose.kexia"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "headTitle"
  }, [_vm._v("舌苔")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.shetai),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "shetai", $$v)
      },
      expression: "diagnose.shetai"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "headTitle"
  }, [_vm._v("脉象")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.pulseCondition),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "pulseCondition", $$v)
      },
      expression: "diagnose.pulseCondition"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "zhenduan"
  }, [_c('h5', {
    staticClass: "westernMedicine"
  }, [_vm._v("西医诊断")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "1、2、3、4、5"
    },
    model: {
      value: (_vm.diagnose.wdiagnosisResult),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "wdiagnosisResult", $$v)
      },
      expression: "diagnose.wdiagnosisResult"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "westernMedicine"
  }, [_vm._v("中医诊断")]), _vm._v(" "), _c('h5', [_vm._v("病症名：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.mdiseasesZh),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "mdiseasesZh", $$v)
      },
      expression: "diagnose.mdiseasesZh"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("英文病症名：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.mdiseasesEn),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "mdiseasesEn", $$v)
      },
      expression: "diagnose.mdiseasesEn"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("证型：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.diagnose.mdiagnosisResult),
      callback: function($$v) {
        _vm.$set(_vm.diagnose, "mdiagnosisResult", $$v)
      },
      expression: "diagnose.mdiagnosisResult"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "inOne-TabBttom"
  }, [(_vm.exhibition) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.futureSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v("保存")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v("保存")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "border-radius": "10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.resetData()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("重置")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a7cf0de6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/inquiry/inquiryRecords.vue
// module id = 1040
// module chunks = 2